import auth from './auth'
import client from './client'
import core from './core'

export default {
  core,
  client,
  auth,
}
